import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy} from '@angular/core';




@Component({
    selector: 'project-list',
    template: require('./project-list.component.html')

})

export class ProjectListComponent implements OnInit, AfterViewInit, OnDestroy {

    constructor(    ) {

    }
    ngOnInit(): void {}
    ngOnDestroy(): void {}
    ngAfterViewInit() {}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project-list/project-list.component.ts